import React from "react";

import DromoUploaderButton from "../Common/DromoUploaderButton";
import getUserDromoUploadFields from "./UserDromoFields";

const UserDromoUploader = ({ resultsHandler }) => {
  return (
    <DromoUploaderButton
      fields={getUserDromoUploadFields(process.env.REACT_APP_PLATFORM_TYPE)}
      importIdentifier="Bulk Users"
      resultsHandler={resultsHandler}
      buttonText="Click to Upload Users"
    />
  );
};

export default UserDromoUploader;
